import { DownloadOutlined } from "@ant-design/icons";
import { saveAs } from "file-saver";
import json2csv from "json2csv";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { customerBillingList } from "../actions/shipmentNPayment";
import Table from "../common/Table";
import { amountFormat } from "../config/helper";
import { NavWrap, TableWrap } from "./ShopForTyres";

const Payments = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const billing_list = useSelector(
    (state) => state?.shipNPay?.customer_billing_list
  );
  const [dates, setDates] = useState({});
  const [filters, setFilters] = useState({
    invoice_status: "A",
  });

  const location = useLocation();

  useEffect(() => {
    let fils = location?.state?.filters ? location?.state?.filters : filters;
    if (location?.state?.filters) {
      setFilters(fils);
      history.replace("/payments");
    }
    if (dates.start_date && dates.end_date) {
      dispatch(
        customerBillingList({
          email: localStorage.getItem("email"),
          ...dates,
          ...fils,
          search_key: "",
        })
      );
      setFilters((fils) => ({ ...fils, search_key: "" }));
    } else {
      if (!dates.start_date && !dates.end_date) {
        dispatch(
          customerBillingList({
            email: localStorage.getItem("email"),
            ...fils,
          })
        );
      }
    }
    // eslint-disable-next-line
  }, [dates]);

  const payment_status = {
    C: "Paid",
    A: "Pending Payment",
    B: "Partially Paid",
  };

  const columns = [
    {
      header: "Shipment ID",
      accessor: "ShipNo",
      width: 15,
    },
    {
      header: "Invoice No",
      accessor: "InvoiceNo",
      width: 15,
    },
    {
      header: "Invoice Date",
      accessor: "BillingDate",
      width: 15,
      cell: (row) => (
        <span>{moment(row.BillingDate, "YYYYMMDD").format("MM/DD/YY")}</span>
      ),
    },
    {
      header: "Due Date",
      accessor: "BillingDueDate",
      width: 15,
      cell: (row) => (
        <span>
          {moment(row.BillingDueDate, "YYYYMMDD").format("MM/DD/YY")}
        </span>
      ),
    },
    // {
    //   header: "Quantity Shipped",
    //   accessor: "Kwmeng",
    //   width: 12,
    //   cell: (row) => <span>{parseInt(row.Kwmeng)}</span>,
    // },
    {
      header: "Total Amount",
      accessor: "BillingNetValue",
      width: 15,
      cell: (row) => <span>$ {amountFormat(row.BillingNetValue)}</span>,
    },
    {
      header: "Order Type",
      accessor: "Vtweg",
      width: 8,
      cell: (row) => (row.Vtweg === "41" ? "FTL" : "FD"),
    },
    {
      header: "Payment Status",
      accessor: "InvoiceClearing",
      width: 12,
      cell: (row) => (
        <span className="success-text">
          {payment_status[row.InvoiceClearing] || "Pending"}
        </span>
      ),
    },
  ];

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={"Payments"}
          showGrid={false}
          showTerms={true}
          isRange={true}
          rangePlaceholder={["Invoice Start date", "Invoice End date"]}
          exportComponent={
            <button
              disabled={
                billing_list?.loading ||
                !billing_list?.data?.billing_list?.length
              }
              onClick={() => {
                let prods = billing_list?.data?.billing_list?.map((ele) => ({
                  "Shipment ID": ele.ShipNo,
                  "Invoice No": ele.InvoiceNo,
                  "Invoice Date":
                    ele.BillingDate && !ele.BillingDate?.includes("0000")
                      ? moment(ele.BillingDate, "YYYYMMDD").format("MM/DD/YY")
                      : "",
                  "Due Date":
                    ele.BillingDueDate && !ele.BillingDueDate?.includes("0000")
                      ? moment(ele.BillingDueDate, "YYYYMMDD").format(
                          "MM/DD/YY"
                        )
                      : "",
                  // "Quantity Shipped": ele.Kwmeng,
                  "Total Amount": parseFloat(ele.BillingNetValue).toFixed(2),
                  "Payment Status": payment_status[ele.InvoiceClearing],
                }));
                let csv = json2csv.parse(prods);
                var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
                saveAs(blob, "Payments.csv");
              }}
            >
              <DownloadOutlined color="#333" />
            </button>
          }
          onRangeChange={(val) => {
            let start_date = val?.[0]
              ? moment(val?.[0]).format("YYYY-MM-DD")
              : null;
            let end_date = val?.[1]
              ? moment(val?.[1]).format("YYYY-MM-DD")
              : null;
            if (val === null) {
              setDates({});
            } else {
              if (start_date && end_date) {
                setDates({
                  start_date,
                  end_date,
                });
              }
            }
          }}
          searchPlaceholder={"Search by invoice no..."}
          callSearch={(search) => {
            let obj = {
              email: localStorage.getItem("email"),
            };
            if (dates.end_date && dates.start_date) {
              dispatch(
                customerBillingList({
                  ...obj,
                  ...dates,
                  ...filters,
                  search_key: search,
                })
              );
            } else {
              dispatch(
                customerBillingList({ ...obj, ...filters, search_key: search })
              );
            }
            setFilters((f) => ({ ...f, search_key: search }));
          }}
          searchVal={filters.search_key ? filters.search_key : ""}
          namedFilters={[
            {
              label: "Pending Payment",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  invoice_status: "A",
                };
                if (filters?.search_key) {
                  obj.search_key = filters?.search_key;
                }
                if (dates.end_date && dates.start_date) {
                  obj = { ...obj, ...dates };
                }
                dispatch(customerBillingList(obj));
                setFilters((f) => ({ ...f, invoice_status: "A" }));
              },
              isActive: filters.invoice_status === "A",
            },
            {
              label: "Partially Paid",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  invoice_status: "B",
                };
                if (filters?.search_key) {
                  obj.search_key = filters?.search_key;
                }
                if (dates.end_date && dates.start_date) {
                  obj = { ...obj, ...dates };
                }
                dispatch(customerBillingList(obj));
                setFilters((f) => ({ ...f, invoice_status: "B" }));
              },
              isActive: filters.invoice_status === "B",
            },
            {
              label: "Completed",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  invoice_status: "C",
                };
                if (filters?.search_key) {
                  obj.search_key = filters?.search_key;
                }
                if (dates.end_date && dates.start_date) {
                  obj = { ...obj, ...dates };
                }
                dispatch(customerBillingList(obj));
                setFilters((f) => ({ ...f, invoice_status: "C" }));
              },
              isActive: filters.invoice_status === "C",
            },
            {
              label: "All ",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  ...filters,
                  invoice_status: "",
                  search_key: "",
                };
                delete obj.invoice_status;
                if (dates.end_date && dates.start_date) {
                  obj = { ...obj, ...dates };
                }
                dispatch(customerBillingList(obj));
                setFilters((f) => ({
                  ...f,
                  invoice_status: "",
                  search_key: "",
                }));
              },
            },
          ]}
          isDateFilter={true}
          options={[{ label: "All Dates", value: "all" }]}
          label={""}
        >
          <Table
            columns={columns}
            data={billing_list?.data?.billing_list}
            action={false}
            actionWidth={8}
            onRowClick={(row) => {
              history.push("/payment-doc/" + row?.InvoiceNo, {
                from: "payments",
                order_no: row?.OrderId,
                time: moment(row?.SoDate, "YYYYMMDD").format("DD MMM, YYYY"),
                billNo: row?.InvoiceNo,
                filters,
              });
            }}
          />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default Payments;
